module.exports = __webpack_public_path__ + "static/disponivel-na-app-store-7585bd2d4876a4dfd29215c94ff06ec3.svg";